import { defineComponent as _defineComponent } from 'vue'
import { computed, ref, watch } from 'vue'
import LojaService from '@/services/LojaService'
import { Loja } from '../../../common/types/Loja'
import ItemListaDetalhes from '@/components/ItemListaDetalhes.vue'
import Irmao, { SituacaoDoMacon } from '../../../common/types/Irmao'
import ComponentAuthGuard from '@/components/ComponentAuthGuard.vue'
import SeletorDeSituacaoDoMacon from '@/components/SeletorDeSituacaoDoMacon.vue'
import { adminLojaGuard as guardaDeAdminDaLoja } from '../../shareds/sharedsLoja'
import { formatarData } from '@/shareds/formatadores'
import { obterCargoDeAdminDaLoja, ordenarIrmaosPorCargo } from './../../../common/shareds/sharedsIrmao'
import CardsDeTotaisPorGrau from '@/components/CardsDeTotaisPorGrau.vue'
import { getErrorMessage } from '@/helpers/error-helpers'


export default /*#__PURE__*/_defineComponent({
  __name: 'DetalharLoja',
  props: {
	id: { type: String, required: true },
},
  setup(__props) {

const props = __props;



const iframeIsLoading = ref(true)
const dialogoEndereco = ref(false)

const loja = ref<Loja | null>(null)
const irmaos = ref<Irmao[]>([])
const situacaoDoMacon = ref<SituacaoDoMacon>('Regular')

const tab = ref(0)
const tabs = [
	// 'Geral',
	'Irmãos',
]

const lojaReq = ref({
	carregando: true,
	erro: '',
})

const irmaosReq = ref({
	carregando: true,
	erro: '',
})

const adminLojaGuard = computed(() => guardaDeAdminDaLoja(props.id))

const irmaosOrdenados = computed(() => ordenarIrmaosPorCargo(irmaos.value, props.id))

async function buscarLoja() {
	lojaReq.value = {
		carregando: true,
		erro: '',
	}
	try {
		loja.value = await LojaService.get(props.id)
	} catch (error) {
		lojaReq.value.erro = getErrorMessage(error)
	} finally {
		lojaReq.value.carregando = false
	}
}

async function buscarIrmaos() {
	irmaosReq.value = {
		carregando: true,
		erro: '',
	}
	try {
		irmaos.value = await LojaService.getIrmaos(props.id, {
			situacaoDoMacon: situacaoDoMacon.value,
		})
	} catch (error) {
		irmaosReq.value.erro = getErrorMessage(error)
	} finally {
		irmaosReq.value.carregando = false
	}
}

watch(situacaoDoMacon, buscarIrmaos)

buscarLoja()
buscarIrmaos()

return { __sfc: true,props, iframeIsLoading, dialogoEndereco, loja, irmaos, situacaoDoMacon, tab, tabs, lojaReq, irmaosReq, adminLojaGuard, irmaosOrdenados, buscarLoja, buscarIrmaos, ComponentAuthGuard, SeletorDeSituacaoDoMacon, formatarData, obterCargoDeAdminDaLoja, CardsDeTotaisPorGrau }
}

})